// import router from '../router/index'

// const API_URL = 'http://localhost:9080/'
// const LOGIN_URL = API_URL + 'login'

export default {
  user: {
    authenticated: false
  },

  logout (context) {
    context.$auth.logout({
      makeRequest: false,
      params: {},
      success: function () {
      },
      error: function () {
      },
      redirect: '/login'
    })
  },

  getAuthHeader () {
    return {
      'Authorization': localStorage.getItem('id_token')
    }
  },
  isAuth (context) {
    return context.$auth.check()
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js